// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"videoModule-module--wrapper--3y2nt"};